"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _classnames4 = _interopRequireDefault(require("classnames"));
var _reactRedux = require("react-redux");
var _arrowUp = _interopRequireDefault(require("cccisd-icons/arrow-up16"));
var _helpers = require("../../helpers.js");
var _assets = require("../../selectors/assets.js");
var _style = _interopRequireDefault(require("./style.css"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var ThumbnailView = /*#__PURE__*/function (_React$Component) {
  function ThumbnailView() {
    var _this;
    _classCallCheck(this, ThumbnailView);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, ThumbnailView, [].concat(args));
    _defineProperty(_this, "scrollToSelected", function (prevProps) {
      var _this$props = _this.props,
        selectedFile = _this$props.selectedFile,
        selectedFolder = _this$props.selectedFolder;
      if (selectedFile === prevProps.selectedFile && selectedFolder === prevProps.selectedFolder) {
        return;
      }
      var selectedItems = _this.wrapper.getElementsByClassName(_style["default"].selected);
      if (selectedItems.length !== 1) {
        return;
      }
      selectedItems[0].scrollIntoView({
        behavior: 'smooth',
        block: 'nearest'
      });
    });
    _defineProperty(_this, "handleKeyDown", function (e) {
      var keys = {
        BACKSPACE: 8,
        ENTER: 13,
        SPACE: 32,
        LEFT: 37,
        UP: 38,
        RIGHT: 39,
        DOWN: 40
      };
      var _this$props2 = _this.props,
        selectedFile = _this$props2.selectedFile,
        selectedFolder = _this$props2.selectedFolder,
        selectedFolderUp = _this$props2.selectedFolderUp;
      var wrapperWidth = _this.wrapper.clientWidth;
      var childWidth = _this.wrapper.firstElementChild.offsetWidth;
      var childGap = childWidth / 9 * 0.8;
      var numberPerRow = Math.floor((wrapperWidth + childGap) / (childWidth + childGap));
      if (Object.values(keys).includes(e.keyCode)) {
        e.preventDefault();
      }
      switch (e.keyCode) {
        case keys.ENTER:
          {
            if (selectedFolderUp) {
              _this.props.goFolderUp();
            } else if (selectedFolder) {
              _this.props.goToFolder(selectedFolder.id);
            }
            break;
          }
        case keys.BACKSPACE:
          _this.props.goFolderUp();
          break;
        case keys.LEFT:
          _this.props.selectNext(-1);
          break;
        case keys.RIGHT:
          _this.props.selectNext(1);
          break;
        case keys.UP:
          _this.props.selectNext(-numberPerRow);
          break;
        case keys.DOWN:
          _this.props.selectNext(numberPerRow);
          break;
        case keys.SPACE:
          {
            if (selectedFile || selectedFolder) {
              _this.props.showInfoModal(true);
            }
            break;
          }
        default:
          break;
      }
    });
    return _this;
  }
  _inherits(ThumbnailView, _React$Component);
  return _createClass(ThumbnailView, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      document.addEventListener('keydown', this.handleKeyDown);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      document.removeEventListener('keydown', this.handleKeyDown);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      this.scrollToSelected.apply(this, arguments);
    }
  }, {
    key: "render",
    value: function render() {
      var _list,
        _this2 = this;
      var list = this.props.list;
      var _this$props$currentFo = this.props.currentFolderData,
        folders = _this$props$currentFo.folders,
        files = _this$props$currentFo.files;
      var parentFolderName = Array.isArray(list) && list.length > 1 ? (_list = list[list.length - 2]) === null || _list === void 0 ? void 0 : _list.name : '..';
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: _style["default"].wrapper,
        ref: function ref(elem) {
          _this2.wrapper = elem;
        }
      }, !this.props.isTopFolder && /*#__PURE__*/_react["default"].createElement("div", {
        className: (0, _classnames4["default"])(_style["default"].item, _defineProperty({}, _style["default"].selected, this.props.selectedFolderUp)),
        onClick: this.props.selectFolder.bind(null, -1),
        onDoubleClick: this.props.goFolderUp,
        "data-folder": true
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: _style["default"].thumbnail + ' ' + _style["default"].folderUp
      }), /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("span", {
        className: "me-1"
      }, /*#__PURE__*/_react["default"].createElement(_arrowUp["default"], null)), parentFolderName)), folders.map(function (item) {
        return /*#__PURE__*/_react["default"].createElement("div", {
          key: item.id,
          className: (0, _classnames4["default"])(_style["default"].item, _defineProperty({}, _style["default"].selected, _this2.props.selectedFolders.includes(item.id))),
          onClick: _this2.props.selectFolder.bind(null, item.id),
          onDoubleClick: _this2.props.goToFolder.bind(null, item.id),
          "data-folder": true
        }, /*#__PURE__*/_react["default"].createElement("div", {
          className: _style["default"].thumbnail + ' ' + _style["default"].folder
        }), /*#__PURE__*/_react["default"].createElement("div", {
          className: "text-center"
        }, (0, _helpers.reduceLength)(item.name, 30)));
      }), files.map(function (item) {
        return /*#__PURE__*/_react["default"].createElement("div", {
          key: item.id,
          className: (0, _classnames4["default"])(_style["default"].item, _defineProperty({}, _style["default"].selected, _this2.props.selectedFiles.includes(item.id))),
          onClick: _this2.props.selectFile.bind(null, item.id),
          "data-file": true
        }, /*#__PURE__*/_react["default"].createElement("div", {
          className: _style["default"].thumbnail,
          style: {
            backgroundImage: "url(".concat(item.thumbnailSmall, ")")
          }
        }), /*#__PURE__*/_react["default"].createElement("div", {
          className: "text-center"
        }, (0, _helpers.reduceLength)(item.name, 30)));
      }));
    }
  }]);
}(_react["default"].Component);
_defineProperty(ThumbnailView, "propTypes", {
  currentFolderId: _propTypes["default"].number,
  currentFolderData: _propTypes["default"].object,
  list: _propTypes["default"].array,
  selectedFolderUp: _propTypes["default"].bool,
  selectedFiles: _propTypes["default"].array,
  selectedFolders: _propTypes["default"].array,
  selectedFile: _propTypes["default"].object,
  selectedFolder: _propTypes["default"].object,
  goToFolder: _propTypes["default"].func,
  goFolderUp: _propTypes["default"].func,
  selectFile: _propTypes["default"].func,
  selectFolder: _propTypes["default"].func,
  selectNext: _propTypes["default"].func,
  showInfoModal: _propTypes["default"].func,
  isTopFolder: _propTypes["default"].bool
});
var mapStateToProps = function mapStateToProps(state, props) {
  return {
    list: (0, _assets.getBreadcrumbs)(state.resources.assets)
  };
};
var _default = exports["default"] = (0, _reactRedux.connect)(mapStateToProps)(ThumbnailView);